<template>
    <div >
        <el-card class="detail-card">
            <ul>
                <li>
                    <p v-show="status == '服务台'&&canIEdit==true">
                        <router-link :to="{ path: '/proAssessComplete',
                                        query: { serialNumber:serialNumber,callback:getDetail }}">
                            <el-button type="primary">分析评估</el-button>
                        </router-link>
                    </p>
                    <p v-show="status == '问题分析与评估'&&canIEdit==true">
                        <router-link :to="{ path: '/proInquiryComplete',
                                        query: { serialNumber:serialNumber,callback:getDetail }}">
                            <el-button type="primary">制定解决方案</el-button>
                        </router-link>
                    </p>
                    <p v-show="status == '制定解决方案'&&canIEdit==true">
                        <router-link :to="{ path: '/proAssessComplete',
                                        query: { serialNumber:serialNumber,callback:getDetail,title:'实施解决方案' }}">
                            <el-button type="primary">实施解决方案</el-button>
                        </router-link>
                    </p>

                    <p v-show="status == '实施解决方案'&&canIEdit==true">
                        <router-link :to="{ path: '/proRemark',
                                        query: { serialNumber:serialNumber,callback:getDetail,type:'close' }}">
                            <el-button type="primary">处理完成</el-button>
                        </router-link>
                    </p>
                    <p v-show="status == '实施解决方案'&&canIEdit==true">
                        <el-button type="primary" @click="appointFn('变更操作')">变更操作</el-button>
                    </p>
                    <p v-show="status == '变更流程'&&canIEdit==true">
                        <router-link :to="{ path: '/proRemark',
                                        query: { serialNumber:serialNumber,callback:getDetail,type:'close' }}">
                            <el-button type="primary">处理完成</el-button>
                        </router-link>
                    </p>
                    <p v-show="status=='服务台'&&recoverEdit==true"><el-button type="primary" @click="recallEvent('撤回')">撤回</el-button></p>
                    <p v-show="status=='创建'&&canIEdit==true"><el-button type="primary" @click="deliver('提交')">提交</el-button></p>
                    <p v-show="status!='创建'&&status == '问题分析与评估'&&canIEdit==true">
                        <router-link :to="{ path: '/proRemark',
                                        query: { serialNumber:serialNumber,callback:getDetail,type:'close' }}">
                            <el-button type="primary">处理完成</el-button>
                        </router-link>
                    </p>
                    <p v-show="status != '处理完成'&&status!='创建'&&canIEdit==true">
                        <router-link :to="{ path: '/proRemark',
                                        query: { serialNumber:serialNumber,callback:getDetail,type:'close',isObserve:true,isRejected:true }}">
                            <el-button type="primary">驳回</el-button>
                        </router-link>
                    </p>

                    <p v-if="status == '观察中'&&canIEdit==true">
                        <router-link :to="{ path: '/proRemark',
                                        query: { serialNumber:serialNumber,callback:getDetail,type:'close',isObserve:true }}">
                            <el-button type="primary">观察完成</el-button>
                        </router-link>

                    </p>
                    <p v-show="status!='服务台'&&status!='处理完成'&&canIEdit==true">
                        <el-button type="primary" @click="appointFn('转交')"  v-w-role="'ITSM-0251'">转交</el-button>
                    </p>
                    <p v-show="status!='处理完成'&&canIEdit==true">
                        <router-link :to="{ path: '/problemAdd',
                                        query: { type:'edit',serialNumber:serialNumber,callback:getDetail }}">
                            <el-button type="primary">编辑</el-button>
                        </router-link>
                    </p>
                    <router-link :to="{ path: '/flowChart',query:{ serialNumber:serialNumber}}">
                        <el-button type="primary">流程跟踪</el-button>
                    </router-link>
                </li>
                <li>
                    <el-row>
                        <router-link  :to="{ path:'/eventAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0218'">提交为事件</el-button>
                        </router-link>
                        <router-link  :to="{ path:'/changeAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0219'">提交为变更</el-button>
                        </router-link>
                        <router-link  :to="{ path:'/problemAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0220'">提交为问题</el-button>
                        </router-link>
                        <router-link  :to="{ path:'/deployAdd',query: { parentNumber:serialNumber,callback:getDetail } }">
                            <el-button type="primary" v-w-role="'ITSM-0221'">提交为发布</el-button>
                        </router-link>
                    </el-row>
                </li>
            </ul>
            <el-row>
                <el-col :span="6"><label>编号：</label>{{ detail.serialNumber }}--{{status}}</el-col>
                <el-col :span="18"><label>标题：</label>{{ detail.title }}</el-col>
            </el-row>
            <el-row>
                <el-col :span="6"><label>请求人：</label>{{ detail.requester }}</el-col>
            </el-row>
        </el-card>
        <div class="tab-card">
            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane :label="item.name" :name="item.index" v-for="item in tabViews" :key="item.index">
                    <div v-loading="loading" v-if="loading" style="width:100%;height:300px;"></div>
                    <keep-alive v-if="!loading">
                        <component :is="currentView"
                                   :detail="detail"
                                   :companyList="companyList"
                                   :eventList="eventList"
                                   :problemList="problemList"
                                   :changeList="changeList"
                                   :deployList="deployList"
                                   :serialNumber="serialNumber"
                                   :hotFAQ="hotFAQ"
                                   :callback="getDetail"
                        ></component>
                    </keep-alive>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
    import services from "./problem.service"
    import commonService from "../../services/common.service"
    import detailForm from "./detailForm.vue";                                      // 表单明细
    import detailHandle from "./detailHandle.vue";                                  // 处理明细
    import WorkHours from "../common/detail/detailWorkHours.vue";                  // 工时/成本
    import SolveProject from "../common/detail/detailSolveProject.vue";            // 解决方案
    import HistoricRecords from "../common/detail/detailHistoricRecords.vue";      // 历史记录
    import HistoricNews from "../common/detail/detailHistoricNews.vue";            // 历史消息
    import detailKnowledge from "../common/detail/detailKnowledge.vue";            // 推荐知识
    import RelevancyEvent from "../common/detail/detailRelevancyEvent.vue";        // 关联事件
    import RelevancyQue from "../common/detail/detailRelevancyQue.vue";            // 关联问题
    import RelevancyChange from "../common/detail/detailRelevancyChange.vue";      // 关联变更
    import RelevancyConfig from "../common/detail/detailRelevancyConfig.vue";      // 关联配置项
    import RelevancyService from "../common/detail/detailRelevancyService.vue";    // 关联服务
    import RelevancyIssue from "../common/detail/detailRelevancyIssue.vue";        // 关联发布
    export default {
        data() {
            return {
                detail:{},
                index:0,
                loading:true,
                activeName:"detailForm",
                tabViews:[
                    { name:"表单明细",index:"detailForm"},
                    { name:"处理明细",index:"detailHandle"},
                    { name:"工时",index:"WorkHours"},
                    { name:"解决方案",index:"SolveProject"},
                    { name:"历史记录",index:"HistoricRecords"},
                    { name:"历史消息",index:"HistoricNews"},
                    { name:"推荐知识",index:"detailKnowledge"},
                    { name:"关联事件",index:"RelevancyEvent"},
                    { name:"关联问题",index:"RelevancyQue"},
                    { name:"关联变更",index:"RelevancyChange"},
                    { name:"关联发布",index:"RelevancyIssue"},
                    { name:"关联配置项",index:"RelevancyConfig"},
                    { name:"关联服务",index:"RelevancyService"},

                ],
                hotFAQ:[],
                status:"",
                currentHandler:"",
                companyList:[],
                eventList:[],
                problemList:[],
                changeList:[],
                deployList:[],
                canIEdit: false,
                recoverEdit:false,
            }
        },
        created() {

            if (this.$route.query){
                // console.log(this.$route.query);
                this.sn = this.$route.query.serialNumber
            }
            // console.log(this.dictionary,'字典')
            this.getDetail();
            this.getCompanyList();
            this.getEventList();
            this.getProblemList();
            this.getChangeList();
            this.getDeployList();

        },
        watch:{
            '$route'(to,from){
                if (to.query.serialNumber != from.query.serialNumber){
                    this.sn = to.query.serialNumber
                    this.getDetail()
                }
            }
        },
        components:{
            detailForm,
            detailHandle,
            WorkHours,
            SolveProject,
            HistoricRecords,
            HistoricNews,
            detailKnowledge,
            RelevancyEvent,
            RelevancyQue,
            RelevancyChange,
            RelevancyConfig,
            RelevancyService,
            RelevancyIssue
        },
        computed:{
            currentView(){
                return this.tabViews[this.index].index;
            },
            query:function () {
                return this.$route.query
            },
            serialNumber:function () {
                return this.query.serialNumber
            },
            dictionary(){
                return this.$store.state.dictionary;
            },
            problemStatus(){
                return this.dictionary.problem_status;
            },
            // 事件分类id
            eventType(){
                return this.$store.state.caseType.event;
            },
            // 问题分类id
            problemType(){
                return this.$store.state.caseType.problem;
            },
            // 变更分类id
            changeType(){
                return this.$store.state.caseType.change;
            },
            // 发布分类id
            deployType(){
                return this.$store.state.caseType.deploy;
            },
            user(){
                return window.localStorage.getItem('internalUserid')
            },
            //登陆的用户角色类型:超管、服务台组、普通用户
            userRole(){
                return window.localStorage.getItem('userRole')
            },

        },
        methods: {
            // 获取所属公司列表
            getCompanyList(){
                commonService.companyList().then(res => {
                    this.companyList = res.list;
                })
            },
            // 获取事件分类
            getEventList(){
                commonService.categoryList(this.eventType.id).then(res => {
                    this.eventList = res;
                })
            },
            // 获取问题分类
            getProblemList(){
                commonService.categoryList(this.problemType.id).then(res => {
                    this.problemList = res;
                })
            },
            // 获取变更分类
            getChangeList(){
                commonService.categoryList(this.changeType.id).then(res => {
                    this.changeList = res;
                    // console.log(this.changeList);
                })
            },
            // 获取发布分类
            getDeployList(){
                commonService.categoryList(this.deployType.id).then(res => {
                    this.deployList = res;
                })
            },
            getRequester(obj){
                // console.log(obj,'obj');
                let params = {
                    currentHandler:obj.internalUserid,
                    handle:"转交",
                    serialNumber:this.serialNumber
                };
                services.handle(params).then(res => {
                    this.$message.success("转交成功");
                    this.getDetail();
                }).catch(err => {
                    this.$message.error(err.message)
                })
            },
            getDetail(){
                if (this.userRole=='super'){
                    this.canIEdit=true
                    this.recoverEdit = true
                }else{
                    this.canIEdit=false
                    this.recoverEdit = false
                }
                services.detail({ serialNumber:this.serialNumber}).then(res => {
                    let resData = {...res}
                    res.requester = res.requester ? res.requester.name : "";
                    res.createUser = res.createUser ? res.createUser.name : "";
                    res.solutionUser = res.solutionUser ? res.solutionUser.name : "";
                    res.updateUser = res.updateUser ? res.updateUser.name : "";
                    res.designator = res.designator ? res.designator.name : "";
                    res.currentHandler.internalUserid&&res.currentHandler.internalUserid==this.user?this.canIEdit=true:''
                    resData.requester.internalUserid&&resData.requester.internalUserid == this.user?this.recoverEdit=true:''

                    res.currentHandler = res.currentHandler ? res.currentHandler.name : "";
                    this.detail =  res;
                    this.status = this.getNameById(res.status,this.problemStatus);
                    if (this.status=='服务台'&&this.userRole=='reception'){
                        this.canIEdit=true
                    }
                    if (this.status=='服务台'&& resData.requester.internalUserid == this.user){
                        this.recoverEdit=true
                    }
                    if (this.status=='创建'&& resData.requester.internalUserid == this.user){
                        this.canIEdit=true
                    }
                    this.search();
                    // if(res.currentDepartment){
                    //     commonService.groupDetail(res.currentDepartment).then(res => {
                    //         this.detail.currentDepartment = res.name;
                    //     })
                    // };
                }).catch(err => {
                    this.$message.error(err.message);
                }).finally(() => {
                    this.loading = false;
                })
            },
            // 撤回
            recallEvent(val){
                this.$confirm('您确定要撤回吗?', '撤回', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    let params = {
                        serialNumber:this.serialNumber,
                        handle: val
                    }
                    commonService.problemHandle(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '撤回成功!'
                        });
                        this.getDetail()
                    }).catch(err => {
                        this.isSubmit=false
                        this.$message.error(err.message);
                    })

                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消撤回'
                  });
                });
            },
            handleClick(tab, event){
                this.index = tab.index;
            },
            search(){//默认查询
                services.getKnowledgeList({"Query":this.detail.title,"pageIndex":1,"pageSize":5}).then(res=>{
                    this.hotFAQ = res.KnowledgeTable;
                })
            },
            // 问题指派
            appointFn(val){
                this.$router.push({
                    path: '/appoint',
                    name: "appoint",
                    query: {
                        type:val,
                        serialNumber:this.serialNumber,
                        callback:this.getDetail,
                        problemTag:true
                    }
                })
            },
            deliver(text){
                this.openMessage('您确定要提交到服务台吗？', '确定', () => {
                    commonService.problemHandle({ handle:text,serialNumber:this.serialNumber }).then(res => {
                        this.$message.success("提交成功");
                        this.getDetail();
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                });
            },
            openMessage(message, confirmText, doit) {
                this.$confirm(message, '提示', {
                    cancelButtonText: '取消',
                    confirmButtonText: confirmText,
                    confirmButtonClass: 'confirmBtn'
                }).then(() => {
                    doit();
                })
            },
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">
    .zebra-item{
        span{
            padding-right: 10px;
        }
    }
    .el-button--mini{
        margin: 0 10px;
    }
</style>
